import { render, staticRenderFns } from "./AboutHero.vue?vue&type=template&id=28c746bf&scoped=true&"
import script from "./AboutHero.vue?vue&type=script&lang=js&"
export * from "./AboutHero.vue?vue&type=script&lang=js&"
import style0 from "./AboutHero.vue?vue&type=style&index=0&id=28c746bf&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c746bf",
  null
  
)

export default component.exports